import { Button, SvgIcons } from "@tripian/react";
import React, { useEffect, useState } from "react";
import useTranslate from "../../hooks/useTranslate";

interface VisaErrorModalProps {
  title?: string;
  description?: string;
  message?: string;
  secondsRemaining: number;
  onManualRedirect: () => void;
  onRetry?: () => void;
}

const VisaErrorModal: React.FC<VisaErrorModalProps> = ({
  title,
  description,
  message,
  secondsRemaining: initialSeconds,
  onManualRedirect,
  onRetry,
}) => {
  const { t } = useTranslate();
  const [seconds, setSeconds] = useState(initialSeconds);

  useEffect(() => {
    const timer = setInterval(() => {
      setSeconds(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          onManualRedirect();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [onManualRedirect]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[2000]">
      <div className="bg-white rounded-2xl shadow-xl max-w-md text-center p-6">
        <div className="flex justify-center items-center mb-4">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-red-600">
            <SvgIcons.Exclamation2 size="2rem" fill="#fff" />
          </div>
        </div>
        <div className="px-6">
          <h2 className="text-xl font-semibold mb-4 text-red-600">
            {title || t("visa.error.title")}
          </h2>
          <p className="mb-2">{description || message}</p>
          <p className="text-sm text-gray-500 mb-8">
            {t("visa.error.redirecting")} ({seconds})
          </p>
          <div className="flex gap-3">
            {onRetry && (
              <Button
                color="secondary"
                text="Tekrar Dene"
                onClick={onRetry}
                className="flex-1 rounded-full transition"
              />
            )}
            <Button
              color="primary"
              text={t("continue")}
              onClick={() => {
                setSeconds(0);
                onManualRedirect();
              }}
              className={`!bg-red-600 text-white px-6 rounded-full transition ${
                onRetry ? "flex-1" : "w-full"
              }`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisaErrorModal;
